
define('text!common/views/commercial/creatives/logo.html',[],function () { return '<div class="ad-slot--paid-for-badge__inner">\n    <%=header%>\n    <%=logo%>\n    <%=partners%>\n    <%=aboutLink%>\n</div>\n';});

